import { useState, useEffect } from 'react';
import Loading from '../../../shared/Loading/Loading';
import ContactService from '../../../services/contact_service';

const Count = ({logout, isSuperAdmin, message}) => {
  const [amount, setAmount] = useState('-');
  const [loading, setLoading] = useState(false)
  
  useEffect(() => {
    (async () => {
      setLoading(true)
      try {
        const users = await ContactService.getAll({
          roles: isSuperAdmin ? 'Super Administrador' : 'Usuario',
          ignore: isSuperAdmin
        });
        if (logout(users)) return;
        setAmount(users?.total || '-')
      } catch(e) {
        message(e?.message || e, "error");
      } finally {
        setLoading(false)
      }
    })();
  }, []);

  return (
    <div className="bg-white shadow-md overflow-hidden rounded-lg w-full flex items-center justify-center">
      <div className="flex flex-col items-center justify-center text-center">
        {loading ? (
          <div className="flex justify-center items-center">
            <Loading
              size="28"
              colorBase="blue-50"
              colorAccent="personalized"
              double={true}
              bold="8"
            />
          </div>
        ) : (
          <p className="text-7xl font-bold leading-none text-gray-300 mt-6">
            {amount}
          </p>
        )}
        <p className="text-2xl text-gray-700 mb-6 font-semibold">
          Usuarios {isSuperAdmin ? 'en el sistema' : 'registrados'}
        </p>
      </div>
    </div>
  );
};

export default Count;
